import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=9bcc0be2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=9bcc0be2&lang=scss&scoped=true"
import style1 from "./Menu.vue?vue&type=style&index=1&id=9bcc0be2&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc0be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\java_code\\esp-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bcc0be2')) {
      api.createRecord('9bcc0be2', component.options)
    } else {
      api.reload('9bcc0be2', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=9bcc0be2&scoped=true", function () {
      api.rerender('9bcc0be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menu.vue"
export default component.exports